<template>
  <div>
    <v-card class="mx-auto">
      <v-card-text>
        <v-btn color="success" class="mr-4" @click="createQuestion()"> Create </v-btn>
        <v-list>
          <template v-for="question in info.questions">
            <v-list-item :key="question.id" :to="'/admin/question/' + question.id">
              <v-list-item-content>
                <div>
                  Question:
                  {{ question.text }}
                </div>
                <div>
                  If Tag:
                  {{
                    question.ifTagId ? (tags[question.ifTagId] ? tags[question.ifTagId].text : '[NOT FOUND]') : '[NONE]'
                  }}
                </div>
                <div>
                  <b>
                    id:
                    {{ question.id }}
                  </b>
                </div>
                <div>
                  <b>
                    Multiple:
                    {{ question.multiple }}
                  </b>
                </div>
                <div>
                  <b>
                    Hidden:
                    {{ question.hidden }}
                  </b>
                </div>
                <v-list two-line>
                  <template v-for="answer in question.answers">
                    <v-list-item :key="answer.id">
                      <v-list-item-content>
                        <v-list-item-title v-html="answer.text"></v-list-item-title>
                        <v-list-item-subtitle v-html="answerTagsText(answer)"></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// Import Vue FilePond

/* eslint-disable no-debugger */

import API from '../../api';

/* eslint-disable-next-line  */

export default {
  name: 'Profile',
  props: {},
  mounted() {
    document.title = 'Admin Questions';
  },
  data: () => ({
    error: null,
    info: [],
    tags: {},
    categories: {},
    tab: ''
  }),
  //LOAD
  created: async function () {
    this.error = null;
    let res = await API.get('admin/info');
    if (!res) {
      return;
    }
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      this.error = null;
      this.info = res.data.info;
      for (let index = 0; index < res.data.info.tags.length; index++) {
        const tag = res.data.info.tags[index];
        this.tags[tag.id] = tag;
      }
      for (let index = 0; index < res.data.info.categories.length; index++) {
        const category = res.data.info.categories[index];
        this.categories[category.id] = category;
      }
    }
  },
  computed: {},
  methods: {
    tagCategoriesText(tag) {
      let res = tag.TagCategories;
      if (!res) {
        return '';
      }

      res = res.map(category =>
        this.categories[category.categoryId] ? this.categories[category.categoryId].name : ''
      );
      return res.join(', ');
    },
    answerTagsText(question) {
      let res = question.tag;
      if (!res) {
        return '';
      }

      res = res.map(tag => (this.tags[tag] ? this.tags[tag].text : ''));
      return res.join(', ');
    },
    createTag() {
      this.$router.push('/admin/tag/new');
    },
    createQuestion() {
      this.$router.push('/admin/question/new');
    }
  }
};
</script>

<style></style>
